;(function () {
  'use strict'
  angular.module('contrast.security').constant('sessionTimeoutInterval', {
    TWO_HOURS: {
      label: '2 hours',
      value: 120,
      translationId: 'detail_hours_plural',
      translationVariable: 2
    },
    FOUR_HOURS: {
      label: '4 hours',
      value: 240,
      translationId: 'detail_hours_plural',
      translationVariable: 4
    },
    EIGHT_HOURS: {
      label: '8 hours',
      value: 480,
      translationId: 'detail_hours_plural',
      translationVariable: 8
    },
    ONE_DAY: {
      label: '24 hours',
      value: 1440,
      translationId: 'detail_hours_plural',
      translationVariable: 24
    }
  })
})()
